import type { DisplayPublic } from '../api';
import { ChannelChrome } from './ChannelChrome';

/**
 * Chroma-key scoreboard bug for OBS / vMix capture. The page background
 * is transparent (set body bg in the kiosk OS to your key color, e.g.
 * lime green) and only the lower-third bar is rendered.
 */
export function StreamOverlayChannel({
  display,
  connected,
  onUnpair,
}: {
  display: DisplayPublic;
  connected: boolean;
  onUnpair: () => void;
}) {
  return (
    <ChannelChrome
      display={display}
      connected={connected}
      onUnpair={onUnpair}
      variant="transparent"
    >
      <div className="flex min-h-screen items-end justify-start p-8">
        <div className="flex items-center gap-4 rounded-xl bg-black/85 px-6 py-4 text-white shadow-2xl backdrop-blur">
          <span className="flex h-12 w-12 items-center justify-center rounded-md bg-blue-500 font-bold">
            HM
          </span>
          <span className="font-mono text-3xl font-bold">0</span>
          <span className="text-white/40">–</span>
          <span className="font-mono text-3xl font-bold">0</span>
          <span className="flex h-12 w-12 items-center justify-center rounded-md bg-red-500 font-bold">
            AW
          </span>
          <span className="ml-4 font-mono text-sm text-white/50">
            Q1 · 12:00
          </span>
        </div>
      </div>
    </ChannelChrome>
  );
}
